import { Box, Avatar, Typography } from '@mui/material'

/**
 * Props for Driver component.
 */
interface DriverProps {
	/**
	 * Example prop - replace with actual props
	 */
	pictureB16: string
	driverName: string
	isCompact: boolean
}

/**
 * Driver component
 *
 * @param {DriverProps} props - Component props
 * @returns {JSX.Element} The rendered Driver component
 */
const Driver = ({ pictureB16, driverName, isCompact }: DriverProps) => {
	const size = isCompact ? '20px' : '32px'

	return (
		<Box
			sx={{
				height: isCompact ? '32px' : '48px',
				display: 'flex',
				alignItems: 'center',
				gap: '0.5rem',
			}}
		>
			<Avatar
				src={pictureB16}
				alt={driverName}
				sx={{
					width: size,
					height: size,
					borderRadius: '100%',
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					justifyContent: 'center',
					bgcolor: 'lightgrey 50% / cover no-repeat',
					fontSize: '20px',
					fontWeight: 400,
					lineHeight: 1,
				}}
			/>
			<Typography
				sx={{
					fontFamily: 'var(--font-family)',
					fontSize: '12px',
					fontStyle: 'normal',
					fontWeight: 400,
					lineHeight: '130%',
					color: 'var(--primary-dark)',
				}}
			>
				{driverName}
			</Typography>
		</Box>
	)
}

export default Driver
